export default [
    {id: 1, group: 'berry', collection: 'plantsInTheCity', power: 3, color: 'red', icons: [
        {"x": -0.4, "y": -0.15, "rotate": 0, "size": 3, "icon": "mdi-tree"},
        {"x": -0.37, "y": 0.55, "rotate": 90, "size": 3, "icon": "mdi-minus"},
        {"x": -0.65, "y": 0.35, "rotate": 0, "size": 0.6, "icon": "mdi-food-apple"},
        {"x": -0.1, "y": 0.25, "rotate": 0, "size": 0.65, "icon": "mdi-food-apple"},
        {"x": 0.4, "y": 0.2, "rotate": 25, "size": 0.6, "icon": "mdi-food-apple"},
        {"x": 0.05, "y": 0.7, "rotate": 0, "size": 0.5, "icon": "mdi-food-apple"},
        {"x": 0.3, "y": 0.75, "rotate": 0, "size": 0.45, "icon": "mdi-food-apple"},
        {"x": 0.75, "y": 0.67, "rotate": 0, "size": 1.6, "icon": "mdi-human-greeting"},
        {"x": 0.2, "y": 0.85, "rotate": 0, "size": 1, "icon": "mdi-basket"}
    ]},
    {id: 2, group: 'vegetable', collection: 'plantsInTheCity', power: 3, color: 'orange', icons: [
        {"x": -0.7, "y": 0.9, "rotate": 0, "size": 2, "icon": "mdi-train-car-flatbed"},
        {"x": -0.7, "y": 0.7, "rotate": 0, "size": 1.65, "icon": "mdi-pumpkin"},
        {"x": 0.5, "y": 1, "rotate": 0, "size": 1.1, "icon": "mdi-pumpkin"},
        {"x": 0.05, "y": 1.08, "rotate": 0, "size": 0.7, "icon": "mdi-pumpkin"},
        {"x": -0.2, "y": -0.3, "rotate": 0, "size": 1.4, "icon": "mdi-human-male-female-child"},
        {"x": 0.8, "y": 0.1, "rotate": 0, "size": 1.3, "icon": "mdi-human-greeting"},
        {"x": 0.4, "y": -0.15, "rotate": 20, "size": 0.6, "icon": "mdi-trophy"}
    ]},
    {id: 3, collection: 'plantsInTheCity', power: 2, reward: [
        {name: 'farmGoldChance', type: 'mult', value: 1.15}
    ], color: 'pale-purple', icons: [
        {"x": -0.75, "y": 0.65, "rotate": 0, "size": 1.5, "icon": "mdi-pot"},
        {"x": 0, "y": 0.65, "rotate": 0, "size": 1.5, "icon": "mdi-pot"},
        {"x": -0.75, "y": 0.35, "rotate": 0, "size": 1, "icon": "mdi-flower"},
        {"x": 0, "y": 0.35, "rotate": 0, "size": 1, "icon": "mdi-flower-tulip"},
        {"x": 0.8, "y": 0.68, "rotate": 0, "size": 1.35, "icon": "mdi-watering-can"},
        {"x": 0.45, "y": -0.65, "rotate": 0, "size": 2, "icon": "mdi-cash-register"}
    ]},
    {id: 4, group: 'flower', collection: 'plantsInTheCity', power: 3, color: 'pale-blue', icons: [
        {"x": 0, "y": 0.25, "rotate": 0, "size": 2, "icon": "mdi-desk"},
        {"x": 0, "y": -0.3, "rotate": 0, "size": 1.5, "icon": "mdi-desktop-tower-monitor"},
        {"x": -0.9, "y": 0.2, "rotate": 0, "size": 1.5, "icon": "mdi-chair-rolling"},
        {"x": 0.95, "y": 0.45, "rotate": 0, "size": 1.25, "icon": "mdi-pot"},
        {"x": 0.95, "y": 0.15, "rotate": 0, "size": 1, "icon": "mdi-flower"}
    ]},
    {id: 5, group: 'grain', collection: 'plantsInTheCity', power: 3, color: 'pale-yellow', icons: [
        {"x": 0, "y": 0.3, "rotate": 0, "size": 1, "icon": "mdi-tshirt-crew"},
        {"x": 0, "y": -0.15, "rotate": 0, "size": 1, "icon": "mdi-hat-fedora"},
        {"x": 0, "y": 0.65, "rotate": 90, "size": 1, "icon": "mdi-minus-thick"},
        {"x": 0.25, "y": 0.3, "rotate": 45, "size": 1, "icon": "mdi-minus"},
        {"x": -0.25, "y": 0.3, "rotate": -45, "size": 1, "icon": "mdi-minus"},
        {"x": -0.8, "y": 0.5, "rotate": 0, "size": 1.25, "icon": "mdi-barley"},
        {"x": -0.8, "y": 0.02, "rotate": 0, "size": 1.25, "icon": "mdi-barley"},
        {"x": 0.75, "y": 0.45, "rotate": 0, "size": 1.4, "icon": "mdi-barley"}
    ]},

    {id: 6, group: 'berry', collection: 'supplyAndSupport', power: 1, reward: [
        {name: 'farmCropGain', type: 'mult', value: 1.35}
    ], color: 'light-blue', icons: [
        {"x": 0.05, "y": -0.45, "rotate": 45, "size": 2, "icon": "mdi-airplane"},
        {"x": -0.2, "y": 0, "rotate": 0, "size": 0.6, "icon": "mdi-water"},
        {"x": 0.4, "y": 0.1, "rotate": 0, "size": 0.6, "icon": "mdi-water"},
        {"x": 0.1, "y": 0.2, "rotate": 0, "size": 0.6, "icon": "mdi-water"},
        {"x": -0.1, "y": 0.35, "rotate": 0, "size": 0.6, "icon": "mdi-water"},
        {"x": 0.3, "y": 0.45, "rotate": 0, "size": 0.6, "icon": "mdi-water"},
        {"x": -0.35, "y": 0.5, "rotate": 0, "size": 0.6, "icon": "mdi-water"},
        {"x": 0, "y": 1, "rotate": 0, "size": 1.5, "icon": "mdi-grass"},
        {"x": -0.65, "y": 1.1, "rotate": 0, "size": 1, "icon": "mdi-flower"}
    ]},
    {id: 7, group: 'vegetable', collection: 'supplyAndSupport', power: 1, reward: [
        {name: 'farmCropGain', type: 'mult', value: 1.35}
    ], color: 'blue-grey', icons: [
        {"x": -1.05, "y": 0, "rotate": 0, "size": 1.25, "icon": "mdi-train-car-centerbeam-full"},
        {"x": -0.35, "y": 0, "rotate": 0, "size": 1.25, "icon": "mdi-train-car-container"},
        {"x": 0.35, "y": 0, "rotate": 0, "size": 1.25, "icon": "mdi-train-car-flatbed-tank"},
        {"x": 1.05, "y": 0, "rotate": 0, "size": 1.25, "icon": "mdi-train-car-hopper-full"}
    ]},
    {id: 8, group: 'grain', collection: 'supplyAndSupport', power: 1, reward: [
        {name: 'farmCropGain', type: 'mult', value: 1.35}
    ], color: 'beige', icons: [
        {"x": -0.6, "y": -0.3, "rotate": 0, "size": 1.5, "icon": "mdi-home-silo"},
        {"x": 0.25, "y": -0.3, "rotate": 0, "size": 1.5, "icon": "mdi-silo"},
        {"x": 0.15, "y": 0.7, "rotate": 0, "size": 2, "icon": "mdi-car-lifted-pickup"},
        {"x": -0.15, "y": 0.5, "rotate": 0, "size": 0.75, "icon": "mdi-land-rows-horizontal"}
    ]},
    {id: 9, group: 'flower', collection: 'supplyAndSupport', power: 1, reward: [
        {name: 'farmCropGain', type: 'mult', value: 1.35}
    ], color: 'deep-orange', icons: [
        {"x": 0, "y": 0, "rotate": 0, "size": 4.5, "icon": "mdi-hoop-house"},
        {"x": 0, "y": 0.6, "rotate": 0, "size": 0.75, "icon": "mdi-radiator"},
        {"x": 0, "y": -0.4, "rotate": 180, "size": 0.5, "icon": "mdi-lightbulb-on"},
        {"x": -0.65, "y": 0.6, "rotate": 0, "size": 0.75, "icon": "mdi-flower"},
        {"x": 0.65, "y": 0.6, "rotate": 0, "size": 0.75, "icon": "mdi-flower"}
    ]},

    {id: 10, collection: 'feedingTheWorld', power: 2, reward: [
        {name: 'farmCropGain', type: 'mult', value: 1.1}
    ], color: 'lime', icons: [
        {"x": 0.2, "y": 0, "rotate": 0, "size": 2.25, "icon": "mdi-blender"},
        {"x": 0.95, "y": 0.23, "rotate": 0, "size": 1.3, "icon": "mdi-beer"},
        {"x": -0.85, "y": 0.32, "rotate": 0, "size": 1, "icon": "mdi-food-apple"},
        {"x": -0.5, "y": 0.32, "rotate": 0, "size": 1, "icon": "mdi-fruit-pear"}
    ]},
    {id: 11, collection: 'feedingTheWorld', power: 0, reward: [
        {name: 'farmGoldChance', type: 'mult', value: 1.25}
    ], color: 'pale-pink', icons: [
        {"x": -0.5, "y": 0.6, "rotate": 0, "size": 3, "icon": "mdi-minus"},
        {"x": 0.5, "y": 0.6, "rotate": 0, "size": 3, "icon": "mdi-minus"},
        {"x": -0.5, "y": -0.2, "rotate": 0, "size": 3, "icon": "mdi-minus"},
        {"x": 0.5, "y": -0.2, "rotate": 0, "size": 3, "icon": "mdi-minus"},
        {"x": -0.65, "y": 0.3, "rotate": 0, "size": 1, "icon": "mdi-baguette"},
        {"x": -0.3, "y": 0.3, "rotate": 0, "size": 1, "icon": "mdi-baguette"},
        {"x": 0.05, "y": 0.3, "rotate": 0, "size": 1, "icon": "mdi-baguette"},
        {"x": 0.6, "y": 0.35, "rotate": 0, "size": 1, "icon": "mdi-food-croissant"},
        {"x": -0.15, "y": -0.5, "rotate": 0, "size": 1, "icon": "mdi-cupcake"},
        {"x": 0.45, "y": -0.5, "rotate": 0, "size": 1, "icon": "mdi-muffin"}
    ]},
    {id: 12, collection: 'feedingTheWorld', power: 3, reward: [
        {name: 'farmExperience', type: 'base', value: 0.2}
    ], color: 'pale-blue', icons: [
        {"x": 0, "y": 0.25, "rotate": 0, "size": 2, "icon": "mdi-truck"},
        {"x": -0.12, "y": -0.4, "rotate": 0, "size": 1.25, "icon": "mdi-ice-cream"},
        {"x": 0.85, "y": 0.7, "rotate": 0, "size": 1, "icon": "mdi-human-handsdown"},
        {"x": -0.7, "y": 0.9, "rotate": 0, "size": 0.7, "icon": "mdi-human-child"}
    ]},
    {id: 13, collection: 'feedingTheWorld', power: 3, reward: [
        {name: 'farmRareDropChance', type: 'mult', value: 1.1}
    ], color: 'orange', icons: [
        {"x": -0.3, "y": 0.2, "rotate": 0, "size": 2, "icon": "mdi-tray"},
        {"x": 0.55, "y": 0.35, "rotate": 0, "size": 2, "icon": "mdi-human-handsdown"},
        {"x": -0.45, "y": 0.2, "rotate": 0, "size": 0.75, "icon": "mdi-food"},
        {"x": -0.1, "y": 0.25, "rotate": 0, "size": 0.7, "icon": "mdi-french-fries"}
    ]},
    {id: 14, collection: 'feedingTheWorld', power: 3, reward: [
        {name: 'farm_grass', type: 'addRareDrop', value: 4, chance: 0.2, mult: 0.4}
    ], color: 'brown', icons: [
        {"x": 0, "y": 0.5, "rotate": 0, "size": 3, "icon": "mdi-table-furniture"},
        {"x": 0, "y": -0.05, "rotate": 0, "size": 1, "icon": "mdi-food-turkey"},
        {"x": -0.45, "y": 0, "rotate": 0, "size": 0.75, "icon": "mdi-food-variant"},
        {"x": 0.5, "y": -0.05, "rotate": 0, "size": 0.85, "icon": "mdi-bowl"},
        {"x": 0.4, "y": -0.05, "rotate": -10, "size": 0.65, "icon": "mdi-carrot"},
        {"x": 0.55, "y": -0.1, "rotate": 15, "size": 0.65, "icon": "mdi-carrot"}
    ]},
    {id: 15, collection: 'feedingTheWorld', power: 3, reward: [
        {name: 'farmCropGain', type: 'mult', value: 1.1},
        {name: 'farmGoldChance', type: 'mult', value: 1.1}
    ], color: 'light-blue', icons: [
        {"x": 0, "y": 0.4, "rotate": 0, "size": 1.7, "icon": "mdi-human-handsup"},
        {"x": -0.3, "y": -0.05, "rotate": 0, "size": 0.85, "icon": "mdi-candy"},
        {"x": -0.95, "y": 0.45, "rotate": 0, "size": 1.25, "icon": "mdi-candycane"},
        {"x": 0.95, "y": 0.45, "rotate": 0, "size": 1.25, "icon": "mdi-candycane"},
        {"x": 0.75, "y": -0.5, "rotate": 0, "size": 0.8, "icon": "mdi-cake-variant"},
        {"x": -0.3, "y": -0.65, "rotate": 0, "size": 0.55, "icon": "mdi-cupcake"},
        {"x": 0.25, "y": -0.2, "rotate": 0, "size": 0.7, "icon": "mdi-ice-pop"},
        {"x": -0.85, "y": -0.2, "rotate": 0, "size": 0.8, "icon": "mdi-ice-cream"}
    ]},
    {id: 16, collection: 'feedingTheWorld', power: 3, reward: [
        {name: 'farmRareDropChance', type: 'mult', value: 1.05},
        {name: 'farmExperience', type: 'base', value: 0.1}
    ], color: 'light-green', icons: [
        {"x": -0.9, "y": 0.3, "rotate": 0, "size": 1, "icon": "mdi-coffee"},
        {"x": -0.4, "y": 0.3, "rotate": 0, "size": 1, "icon": "mdi-coffee"},
        {"x": -0.65, "y": -0.15, "rotate": 0, "size": 1, "icon": "mdi-coffee"},
        {"x": 0.3, "y": 0.22, "rotate": 0, "size": 1.2, "icon": "mdi-kettle-steam"},
        {"x": 0.95, "y": 0.3, "rotate": 0, "size": 1, "icon": "mdi-tea"}
    ]},
    {id: 17, group: 'flower', collection: 'feedingTheWorld', power: 4, reward: [
        {name: 'farm_petal', type: 'addRareDrop', value: 2, chance: 0.1, mult: 0.1}
    ], color: 'cherry', icons: [
        {"x": -0.6, "y": 0.15, "rotate": 0, "size": 2, "icon": "mdi-bowl"},
        {"x": -0.4, "y": 0.05, "rotate": 60, "size": 1, "icon": "mdi-fruit-grapes"},
        {"x": -0.75, "y": 0.1, "rotate": -15, "size": 1, "icon": "mdi-fruit-grapes"},
        {"x": -0.1, "y": 0.2, "rotate": 0, "size": 1, "icon": "mdi-faucet"},
        {"x": 0.25, "y": 0.3, "rotate": 0, "size": 1.25, "icon": "mdi-bottle-wine"},
        {"x": 0.5, "y": 0.3, "rotate": 0, "size": 1.25, "icon": "mdi-bottle-wine"},
        {"x": 0.75, "y": 0.3, "rotate": 0, "size": 1.25, "icon": "mdi-bottle-wine"},
        {"x": 1.1, "y": 0.37, "rotate": 0, "size": 1, "icon": "mdi-glass-wine"}
    ]},
    {id: 18, collection: 'feedingTheWorld', power: 0, reward: [
        {name: 'farm_petal', type: 'addRareDrop', value: 2, chance: -0.05, mult: 0.02},
        {name: 'farm_seedHull', type: 'addRareDrop', value: 3, chance: -0.05, mult: 0.02},
        {name: 'farm_bug', type: 'addRareDrop', value: 1, chance: -0.05, mult: 0.02}
    ], color: 'wooden', icons: [
        {"x": -0.55, "y": 0, "rotate": 0, "size": 2, "icon": "mdi-coffee-maker"},
        {"x": 0.6, "y": 0.2, "rotate": 0, "size": 1.25, "icon": "mdi-coffee"},
        {"x": 0.65, "y": -0.2, "rotate": 65, "size": 1, "icon": "mdi-cookie"}
    ]},

    {id: 19, group: 'grain', collection: 'organicDyes', power: 3, reward: [
        {name: 'farm_seedHull', type: 'addRareDrop', value: 6, chance: 0.15, mult: 0.1}
    ], color: 'amber', icons: [
        {"x": -0.6, "y": 0.75, "rotate": 0, "size": 1, "icon": "mdi-carrot"},
        {"x": -0.35, "y": 0.75, "rotate": 0, "size": 1, "icon": "mdi-carrot"},
        {"x": -0.1, "y": 0.75, "rotate": 0, "size": 1, "icon": "mdi-carrot"},
        {"x": 0.2, "y": -0.05, "rotate": 0, "size": 1.8, "icon": "mdi-pumpkin"},
        {"x": -0.1, "y": -0.65, "rotate": 0, "size": 1.4, "icon": "mdi-circular-saw"}
    ]},
    {id: 20, group: 'vegetable', collection: 'organicDyes', power: 3, reward: [
        {name: 'farm_bug', type: 'addRareDrop', value: 2, chance: 0.1, mult: 0.1}
    ], color: 'orange-red', icons: [
        {"x": 0, "y": 0, "rotate": 0, "size": 4, "icon": "mdi-tray"},
        {"x": -0.45, "y": 0.25, "rotate": 0, "size": 1, "icon": "mdi-fruit-cherries"},
        {"x": 0, "y": 0.25, "rotate": 0, "size": 1, "icon": "mdi-food-apple"},
        {"x": 0.45, "y": 0.25, "rotate": 0, "size": 1, "icon": "mdi-fruit-watermelon"},
        {"x": 0.3, "y": -0.1, "rotate": 35, "size": 1, "icon": "mdi-chili-hot"},
        {"x": -0.25, "y": -0.15, "rotate": -70, "size": 1, "icon": "mdi-chili-medium"}
    ]},
    {id: 21, group: 'berry', collection: 'organicDyes', power: 3, reward: [
        {name: 'farm_butterfly', type: 'addRareDrop', value: 1, chance: 0, mult: 0.1}
    ], color: 'pale-yellow', icons: [
        {"x": -0.7, "y": 0, "rotate": 0, "size": 1.25, "icon": "mdi-flower"},
        {"x": 0.7, "y": 0, "rotate": 0, "size": 1.25, "icon": "mdi-flower"},
        {"x": 0, "y": -0.2, "rotate": 180, "size": 1.75, "icon": "mdi-flower-pollen"},
        {"x": -0.2, "y": 0.5, "rotate": 0, "size": 1, "icon": "mdi-grain"},
        {"x": 0.2, "y": 0.5, "rotate": 0, "size": 1, "icon": "mdi-grain"},
        {"x": 0, "y": 0.45, "rotate": 0, "size": 2.25, "icon": "mdi-tray"}
    ]},
    {id: 22, collection: 'organicDyes', power: 6, color: 'light-green', icons: [
        {"x": -0.9, "y": 0.4, "rotate": 0, "size": 1.25, "icon": "mdi-grass"},
        {"x": -0.3, "y": 0.4, "rotate": 0, "size": 1.25, "icon": "mdi-grass"},
        {"x": 0.3, "y": 0.4, "rotate": 0, "size": 1.25, "icon": "mdi-grass"},
        {"x": 0.9, "y": 0.4, "rotate": 0, "size": 1.25, "icon": "mdi-grass"},
        {"x": 0, "y": -0.1, "rotate": 0, "size": 1.1, "icon": "mdi-hops"},
        {"x": -0.45, "y": 0.1, "rotate": 0, "size": 0.8, "icon": "mdi-leaf"},
        {"x": -0.8, "y": 0.05, "rotate": -85, "size": 0.8, "icon": "mdi-leaf"},
        {"x": -0.55, "y": -0.15, "rotate": -30, "size": 0.8, "icon": "mdi-leaf"},
        {"x": 0.65, "y": 0.1, "rotate": 50, "size": 0.9, "icon": "mdi-leaf"}
    ]},
    {id: 23, collection: 'organicDyes', power: 4, reward: [
        {name: 'farmOvergrow', type: 'base', value: 1.75}
    ], color: 'dark-blue', icons: [
        {"x": -0.4, "y": 0.2, "rotate": 0, "size": 2, "icon": "mdi-image-filter-drama"},
        {"x": -0.05, "y": 0.05, "rotate": -75, "size": 1, "icon": "mdi-fruit-grapes"},
        {"x": -0.7, "y": 0.15, "rotate": 155, "size": 1, "icon": "mdi-fruit-grapes"},
        {"x": 0.75, "y": 0.15, "rotate": 0, "size": 1.75, "icon": "mdi-human-handsdown"},
        {"x": 1.05, "y": 0.3, "rotate": 0, "size": 0.7, "icon": "mdi-fruit-grapes"},
        {"x": 0.45, "y": 0.3, "rotate": 0, "size": 0.7, "icon": "mdi-basket"}
    ]},
    {id: 24, collection: 'organicDyes', power: 5, reward: [
        {name: 'farmOvergrow', type: 'base', value: 0.6}
    ], color: 'purple', icons: [
        {"x": -0.7, "y": 0, "rotate": 0, "size": 3, "icon": "mdi-tree"},
        {"x": 0.6, "y": -0.4, "rotate": 0, "size": 2.5, "icon": "mdi-pine-tree"},
        {"x": 0.2, "y": 0.8, "rotate": 0, "size": 1, "icon": "mdi-mushroom"},
        {"x": -0.4, "y": 1, "rotate": 0, "size": 1.1, "icon": "mdi-mushroom"},
        {"x": 1, "y": 0.65, "rotate": 0, "size": 0.9, "icon": "mdi-mushroom"},
        {"x": 0.5, "y": 0.45, "rotate": 0, "size": 0.8, "icon": "mdi-mushroom"},
        {"x": 0, "y": 0.25, "rotate": 0, "size": 0.7, "icon": "mdi-mushroom"}
    ]},
    {id: 25, collection: 'organicDyes', power: 3, reward: [
        {name: 'farm_ladybug', type: 'addRareDrop', value: 4, chance: -0.05, mult: 0.1}
    ], color: 'brown', icons: [
        {"x": 0, "y": 0.1, "rotate": 0, "size": 2, "icon": "mdi-bowl-mix"},
        {"x": -0.25, "y": 0, "rotate": -15, "size": 0.7, "icon": "mdi-bug"},
        {"x": 0.3, "y": 0.1, "rotate": 70, "size": 0.7, "icon": "mdi-bug"},
        {"x": 0.05, "y": 0.05, "rotate": 0, "size": 0.7, "icon": "mdi-ladybug"}
    ]},
    {id: 26, collection: 'organicDyes', power: 0, reward: [
        {name: 'farm_spider', type: 'addRareDrop', value: 1, chance: -0.15, mult: 0.05}
    ], color: 'lime', icons: [
        {"x": 0.4, "y": 0, "rotate": -5, "size": 1.5, "icon": "mdi-fruit-pineapple"},
        {"x": 0.9, "y": 0, "rotate": 15, "size": 1.5, "icon": "mdi-fruit-pineapple"},
        {"x": -0.95, "y": 0, "rotate": 0, "size": 1.2, "icon": "mdi-corn"},
        {"x": -0.55, "y": 0.1, "rotate": 45, "size": 1.2, "icon": "mdi-corn"},
        {"x": -0.2, "y": -0.35, "rotate": 0, "size": 1, "icon": "mdi-fruit-citrus"}
    ]},
    {id: 27, collection: 'organicDyes', power: 5, reward: [
        {name: 'farm_bee', type: 'addRareDrop', value: 10, chance: -0.15, mult: 0.1}
    ], color: 'pink', icons: [
        {"x": 0.55, "y": -0.55, "rotate": 0, "size": 1.5, "icon": "mdi-bee-flower"},
        {"x": 0, "y": 1, "rotate": 0, "size": 1.4, "icon": "mdi-flower"},
        {"x": -0.7, "y": 0.5, "rotate": -20, "size": 0.9, "icon": "mdi-butterfly"},
        {"x": 0.7, "y": 0.3, "rotate": 70, "size": 0.85, "icon": "mdi-butterfly"},
        {"x": 0.05, "y": -0.05, "rotate": 145, "size": 0.95, "icon": "mdi-butterfly"},
        {"x": -0.65, "y": -0.5, "rotate": -100, "size": 0.7, "icon": "mdi-butterfly"}
    ]},
];
